// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/artifacts.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * Artifact mirrors services/pangaea/pkg/models/artifact.go::Artifact column-for-column.
 *
 * `storage_provider` is currently always "minio". Express's startup migrator
 * streams legacy GridFS bytes into MinIO and registers the row with
 * `legacy_gridfs_id` set as audit metadata; the GridFS bucket itself is
 * never read once a row exists.
 *
 * @generated from message mono.datagateway.v1.Artifact
 */ export class Artifact extends Message {
    static fromBinary(bytes, options) {
        return new Artifact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Artifact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Artifact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Artifact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * project_id is optional — chat-only uploads (no project context) leave it empty.
   *
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 size_bytes = 7;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: string checksum_sha256 = 8;
   */ _define_property(this, "checksumSha256", ""), /**
   * "minio" | "gridfs"
   *
   * @generated from field: string storage_provider = 9;
   */ _define_property(this, "storageProvider", ""), /**
   * @generated from field: string storage_bucket = 10;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 11;
   */ _define_property(this, "storageKey", ""), /**
   * populated only when storage_provider="gridfs"
   *
   * @generated from field: string legacy_gridfs_id = 12;
   */ _define_property(this, "legacyGridfsId", ""), /**
   * uploading|uploaded|processing|ready|failed|deleted
   *
   * @generated from field: string status = 13;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string file_category = 14;
   */ _define_property(this, "fileCategory", ""), /**
   * @generated from field: string source_kind = 15;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string document_type = 16;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string classification_label = 17;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int32 page_count = 18;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: string chat_id = 19;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string message_id = 20;
   */ _define_property(this, "messageId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 23;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: int32 version = 24;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Artifact, "runtime", proto3);
_define_property(Artifact, "typeName", "mono.datagateway.v1.Artifact");
_define_property(Artifact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "storage_provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "legacy_gridfs_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "deleted_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 24,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UploadSession
 */ export class UploadSession extends Message {
    static fromBinary(bytes, options) {
        return new UploadSession().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadSession().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadSession().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UploadSession, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string upload_url = 3;
   */ _define_property(this, "uploadUrl", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */ _define_property(this, "expiresAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 5;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp aborted_at = 6;
   */ _define_property(this, "abortedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UploadSession, "runtime", proto3);
_define_property(UploadSession, "typeName", "mono.datagateway.v1.UploadSession");
_define_property(UploadSession, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "upload_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "completed_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 6,
            name: "aborted_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProcessingJob
 */ export class ProcessingJob extends Message {
    static fromBinary(bytes, options) {
        return new ProcessingJob().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessingJob().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessingJob().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessingJob, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string requested_by_user_id = 4;
   */ _define_property(this, "requestedByUserId", ""), /**
   * "reverie" today; future "baltigo" etc.
   *
   * @generated from field: string processor = 5;
   */ _define_property(this, "processor", ""), /**
   * reverie's job_id
   *
   * @generated from field: string external_job_id = 6;
   */ _define_property(this, "externalJobId", ""), /**
   * queued|running|completed|failed|cancelled
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 progress_percent = 8;
   */ _define_property(this, "progressPercent", 0), /**
   * @generated from field: string current_step = 9;
   */ _define_property(this, "currentStep", ""), /**
   * @generated from field: string error_message = 10;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 13;
   */ _define_property(this, "completedAt", void 0), /**
   * Estimated wall-clock seconds until completion. 0 = unknown (the processor
   * either hasn't reported one yet or has no historical baseline for this job
   * class). Frontends should treat 0 as "fall back to elapsed-time display".
   *
   * @generated from field: int32 estimated_remaining_seconds = 14;
   */ _define_property(this, "estimatedRemainingSeconds", 0), /**
   * Opaque processing options the job was launched with — same shape as
   * mono.artifact.v1.StartArtifactProcessingRequest.processing_options.
   * Persisted so RetryProcessing can re-run with the user's original choices
   * (deep PDF processing, output format, etc.) instead of system defaults.
   *
   * @generated from field: google.protobuf.Struct processing_options = 15;
   */ _define_property(this, "processingOptions", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessingJob, "runtime", proto3);
_define_property(ProcessingJob, "typeName", "mono.datagateway.v1.ProcessingJob");
_define_property(ProcessingJob, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requested_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "processor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "external_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "progress_percent",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "completed_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 14,
            name: "estimated_remaining_seconds",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "processing_options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArtifactProjectLink
 */ export class ArtifactProjectLink extends Message {
    static fromBinary(bytes, options) {
        return new ArtifactProjectLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArtifactProjectLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArtifactProjectLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArtifactProjectLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string outline_node_id = 3;
   */ _define_property(this, "outlineNodeId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArtifactProjectLink, "runtime", proto3);
_define_property(ArtifactProjectLink, "typeName", "mono.datagateway.v1.ArtifactProjectLink");
_define_property(ArtifactProjectLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "outline_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArtifactEntityLink
 */ export class ArtifactEntityLink extends Message {
    static fromBinary(bytes, options) {
        return new ArtifactEntityLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArtifactEntityLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArtifactEntityLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArtifactEntityLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArtifactEntityLink, "runtime", proto3);
_define_property(ArtifactEntityLink, "typeName", "mono.datagateway.v1.ArtifactEntityLink");
_define_property(ArtifactEntityLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ArtifactFilter is reusable across List queries. Empty fields mean "no filter".
 *
 * @generated from message mono.datagateway.v1.ArtifactFilter
 */ export class ArtifactFilter extends Message {
    static fromBinary(bytes, options) {
        return new ArtifactFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArtifactFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArtifactFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArtifactFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string storage_provider = 6;
   */ _define_property(this, "storageProvider", ""), /**
   * @generated from field: string file_category = 7;
   */ _define_property(this, "fileCategory", ""), /**
   * @generated from field: string source_kind = 8;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string document_type = 9;
   */ _define_property(this, "documentType", ""), /**
   * include_deleted defaults to false — soft-deleted rows are hidden by default.
   *
   * @generated from field: bool include_deleted = 10;
   */ _define_property(this, "includeDeleted", false), /**
   * exclude_document_types drops rows whose document_type is listed (rows
   * with no document_type are kept). Tesoro uses it to keep agent datasets
   * ("agent-dataset") out of every file list that does not ask for them.
   *
   * @generated from field: repeated string exclude_document_types = 11;
   */ _define_property(this, "excludeDocumentTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArtifactFilter, "runtime", proto3);
_define_property(ArtifactFilter, "typeName", "mono.datagateway.v1.ArtifactFilter");
_define_property(ArtifactFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "storage_provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "exclude_document_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetArtifactRequest
 */ export class GetArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactRequest, "runtime", proto3);
_define_property(GetArtifactRequest, "typeName", "mono.datagateway.v1.GetArtifactRequest");
_define_property(GetArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetArtifactResponse
 */ export class GetArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactResponse, "runtime", proto3);
_define_property(GetArtifactResponse, "typeName", "mono.datagateway.v1.GetArtifactResponse");
_define_property(GetArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetArtifactByStorageKeyRequest
 */ export class GetArtifactByStorageKeyRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactByStorageKeyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactByStorageKeyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactByStorageKeyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactByStorageKeyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string storage_provider = 1;
   */ _define_property(this, "storageProvider", ""), /**
   * @generated from field: string storage_bucket = 2;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 3;
   */ _define_property(this, "storageKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactByStorageKeyRequest, "runtime", proto3);
_define_property(GetArtifactByStorageKeyRequest, "typeName", "mono.datagateway.v1.GetArtifactByStorageKeyRequest");
_define_property(GetArtifactByStorageKeyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "storage_provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetArtifactByStorageKeyResponse
 */ export class GetArtifactByStorageKeyResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactByStorageKeyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactByStorageKeyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactByStorageKeyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactByStorageKeyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactByStorageKeyResponse, "runtime", proto3);
_define_property(GetArtifactByStorageKeyResponse, "typeName", "mono.datagateway.v1.GetArtifactByStorageKeyResponse");
_define_property(GetArtifactByStorageKeyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateArtifactRequest
 */ export class CreateArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateArtifactRequest, "runtime", proto3);
_define_property(CreateArtifactRequest, "typeName", "mono.datagateway.v1.CreateArtifactRequest");
_define_property(CreateArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateArtifactResponse
 */ export class CreateArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateArtifactResponse, "runtime", proto3);
_define_property(CreateArtifactResponse, "typeName", "mono.datagateway.v1.CreateArtifactResponse");
_define_property(CreateArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateArtifactRequest
 */ export class UpdateArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateArtifactRequest, "runtime", proto3);
_define_property(UpdateArtifactRequest, "typeName", "mono.datagateway.v1.UpdateArtifactRequest");
_define_property(UpdateArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateArtifactResponse
 */ export class UpdateArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateArtifactResponse, "runtime", proto3);
_define_property(UpdateArtifactResponse, "typeName", "mono.datagateway.v1.UpdateArtifactResponse");
_define_property(UpdateArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * UpsertArtifact exists for the GridFS backfill job (lazy-bridge seed); it
 * inserts on a fresh ID, no-ops on conflict. Domain code uses Create/Update.
 *
 * @generated from message mono.datagateway.v1.UpsertArtifactRequest
 */ export class UpsertArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertArtifactRequest, "runtime", proto3);
_define_property(UpsertArtifactRequest, "typeName", "mono.datagateway.v1.UpsertArtifactRequest");
_define_property(UpsertArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertArtifactResponse
 */ export class UpsertArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertArtifactResponse, "runtime", proto3);
_define_property(UpsertArtifactResponse, "typeName", "mono.datagateway.v1.UpsertArtifactResponse");
_define_property(UpsertArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteArtifactRequest
 */ export class DeleteArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteArtifactRequest, "runtime", proto3);
_define_property(DeleteArtifactRequest, "typeName", "mono.datagateway.v1.DeleteArtifactRequest");
_define_property(DeleteArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteArtifactResponse
 */ export class DeleteArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteArtifactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteArtifactResponse, "runtime", proto3);
_define_property(DeleteArtifactResponse, "typeName", "mono.datagateway.v1.DeleteArtifactResponse");
_define_property(DeleteArtifactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.HardDeleteArtifactRequest
 */ export class HardDeleteArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new HardDeleteArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HardDeleteArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HardDeleteArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HardDeleteArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(HardDeleteArtifactRequest, "runtime", proto3);
_define_property(HardDeleteArtifactRequest, "typeName", "mono.datagateway.v1.HardDeleteArtifactRequest");
_define_property(HardDeleteArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.HardDeleteArtifactResponse
 */ export class HardDeleteArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new HardDeleteArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HardDeleteArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HardDeleteArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HardDeleteArtifactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(HardDeleteArtifactResponse, "runtime", proto3);
_define_property(HardDeleteArtifactResponse, "typeName", "mono.datagateway.v1.HardDeleteArtifactResponse");
_define_property(HardDeleteArtifactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListArtifactsRequest
 */ export class ListArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ArtifactFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactsRequest, "runtime", proto3);
_define_property(ListArtifactsRequest, "typeName", "mono.datagateway.v1.ListArtifactsRequest");
_define_property(ListArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ArtifactFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListArtifactsResponse
 */ export class ListArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Artifact artifacts = 1;
   */ _define_property(this, "artifacts", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactsResponse, "runtime", proto3);
_define_property(ListArtifactsResponse, "typeName", "mono.datagateway.v1.ListArtifactsResponse");
_define_property(ListArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: Artifact,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindArtifactsByChecksumRequest
 */ export class FindArtifactsByChecksumRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindArtifactsByChecksumRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindArtifactsByChecksumRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindArtifactsByChecksumRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindArtifactsByChecksumRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string checksum_sha256 = 2;
   */ _define_property(this, "checksumSha256", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindArtifactsByChecksumRequest, "runtime", proto3);
_define_property(FindArtifactsByChecksumRequest, "typeName", "mono.datagateway.v1.FindArtifactsByChecksumRequest");
_define_property(FindArtifactsByChecksumRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ChecksumFiling is one place a same-bytes artifact is filed.
 *
 * @generated from message mono.datagateway.v1.ChecksumFiling
 */ export class ChecksumFiling extends Message {
    static fromBinary(bytes, options) {
        return new ChecksumFiling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChecksumFiling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChecksumFiling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChecksumFiling, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0), /**
   * program_document | submission | quality | project
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 4;
   */ _define_property(this, "programName", ""), /**
   * delivery.program_documents id when kind is program_document.
   *
   * @generated from field: string program_document_id = 5;
   */ _define_property(this, "programDocumentId", ""), /**
   * @generated from field: string project_id = 6;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChecksumFiling, "runtime", proto3);
_define_property(ChecksumFiling, "typeName", "mono.datagateway.v1.ChecksumFiling");
_define_property(ChecksumFiling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindArtifactsByChecksumResponse
 */ export class FindArtifactsByChecksumResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindArtifactsByChecksumResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindArtifactsByChecksumResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindArtifactsByChecksumResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindArtifactsByChecksumResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ChecksumFiling filings = 1;
   */ _define_property(this, "filings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindArtifactsByChecksumResponse, "runtime", proto3);
_define_property(FindArtifactsByChecksumResponse, "typeName", "mono.datagateway.v1.FindArtifactsByChecksumResponse");
_define_property(FindArtifactsByChecksumResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filings",
            kind: "message",
            T: ChecksumFiling,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateUploadSessionRequest
 */ export class CreateUploadSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateUploadSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUploadSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUploadSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUploadSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UploadSession session = 1;
   */ _define_property(this, "session", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUploadSessionRequest, "runtime", proto3);
_define_property(CreateUploadSessionRequest, "typeName", "mono.datagateway.v1.CreateUploadSessionRequest");
_define_property(CreateUploadSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "session",
            kind: "message",
            T: UploadSession
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateUploadSessionResponse
 */ export class CreateUploadSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateUploadSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUploadSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUploadSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUploadSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UploadSession session = 1;
   */ _define_property(this, "session", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUploadSessionResponse, "runtime", proto3);
_define_property(CreateUploadSessionResponse, "typeName", "mono.datagateway.v1.CreateUploadSessionResponse");
_define_property(CreateUploadSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "session",
            kind: "message",
            T: UploadSession
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetUploadSessionRequest
 */ export class GetUploadSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetUploadSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUploadSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUploadSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUploadSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUploadSessionRequest, "runtime", proto3);
_define_property(GetUploadSessionRequest, "typeName", "mono.datagateway.v1.GetUploadSessionRequest");
_define_property(GetUploadSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetUploadSessionResponse
 */ export class GetUploadSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetUploadSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUploadSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUploadSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUploadSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UploadSession session = 1;
   */ _define_property(this, "session", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUploadSessionResponse, "runtime", proto3);
_define_property(GetUploadSessionResponse, "typeName", "mono.datagateway.v1.GetUploadSessionResponse");
_define_property(GetUploadSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "session",
            kind: "message",
            T: UploadSession
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkUploadSessionCompletedRequest
 */ export class MarkUploadSessionCompletedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkUploadSessionCompletedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkUploadSessionCompletedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkUploadSessionCompletedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkUploadSessionCompletedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkUploadSessionCompletedRequest, "runtime", proto3);
_define_property(MarkUploadSessionCompletedRequest, "typeName", "mono.datagateway.v1.MarkUploadSessionCompletedRequest");
_define_property(MarkUploadSessionCompletedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkUploadSessionCompletedResponse
 */ export class MarkUploadSessionCompletedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkUploadSessionCompletedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkUploadSessionCompletedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkUploadSessionCompletedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkUploadSessionCompletedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UploadSession session = 1;
   */ _define_property(this, "session", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkUploadSessionCompletedResponse, "runtime", proto3);
_define_property(MarkUploadSessionCompletedResponse, "typeName", "mono.datagateway.v1.MarkUploadSessionCompletedResponse");
_define_property(MarkUploadSessionCompletedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "session",
            kind: "message",
            T: UploadSession
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkUploadSessionAbortedRequest
 */ export class MarkUploadSessionAbortedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkUploadSessionAbortedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkUploadSessionAbortedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkUploadSessionAbortedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkUploadSessionAbortedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkUploadSessionAbortedRequest, "runtime", proto3);
_define_property(MarkUploadSessionAbortedRequest, "typeName", "mono.datagateway.v1.MarkUploadSessionAbortedRequest");
_define_property(MarkUploadSessionAbortedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkUploadSessionAbortedResponse
 */ export class MarkUploadSessionAbortedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkUploadSessionAbortedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkUploadSessionAbortedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkUploadSessionAbortedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkUploadSessionAbortedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UploadSession session = 1;
   */ _define_property(this, "session", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkUploadSessionAbortedResponse, "runtime", proto3);
_define_property(MarkUploadSessionAbortedResponse, "typeName", "mono.datagateway.v1.MarkUploadSessionAbortedResponse");
_define_property(MarkUploadSessionAbortedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "session",
            kind: "message",
            T: UploadSession
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProcessingJobRequest
 */ export class CreateProcessingJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProcessingJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProcessingJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProcessingJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProcessingJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProcessingJobRequest, "runtime", proto3);
_define_property(CreateProcessingJobRequest, "typeName", "mono.datagateway.v1.CreateProcessingJobRequest");
_define_property(CreateProcessingJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProcessingJobResponse
 */ export class CreateProcessingJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProcessingJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProcessingJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProcessingJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProcessingJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProcessingJobResponse, "runtime", proto3);
_define_property(CreateProcessingJobResponse, "typeName", "mono.datagateway.v1.CreateProcessingJobResponse");
_define_property(CreateProcessingJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProcessingJobRequest
 */ export class GetProcessingJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobRequest, "runtime", proto3);
_define_property(GetProcessingJobRequest, "typeName", "mono.datagateway.v1.GetProcessingJobRequest");
_define_property(GetProcessingJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProcessingJobResponse
 */ export class GetProcessingJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobResponse, "runtime", proto3);
_define_property(GetProcessingJobResponse, "typeName", "mono.datagateway.v1.GetProcessingJobResponse");
_define_property(GetProcessingJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProcessingJobByExternalIDRequest
 */ export class GetProcessingJobByExternalIDRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobByExternalIDRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobByExternalIDRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobByExternalIDRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobByExternalIDRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string processor = 1;
   */ _define_property(this, "processor", ""), /**
   * @generated from field: string external_job_id = 2;
   */ _define_property(this, "externalJobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobByExternalIDRequest, "runtime", proto3);
_define_property(GetProcessingJobByExternalIDRequest, "typeName", "mono.datagateway.v1.GetProcessingJobByExternalIDRequest");
_define_property(GetProcessingJobByExternalIDRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "processor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "external_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProcessingJobByExternalIDResponse
 */ export class GetProcessingJobByExternalIDResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobByExternalIDResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobByExternalIDResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobByExternalIDResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobByExternalIDResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobByExternalIDResponse, "runtime", proto3);
_define_property(GetProcessingJobByExternalIDResponse, "typeName", "mono.datagateway.v1.GetProcessingJobByExternalIDResponse");
_define_property(GetProcessingJobByExternalIDResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProcessingJobRequest
 */ export class UpdateProcessingJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProcessingJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProcessingJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProcessingJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProcessingJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProcessingJobRequest, "runtime", proto3);
_define_property(UpdateProcessingJobRequest, "typeName", "mono.datagateway.v1.UpdateProcessingJobRequest");
_define_property(UpdateProcessingJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProcessingJobResponse
 */ export class UpdateProcessingJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProcessingJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProcessingJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProcessingJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProcessingJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProcessingJobResponse, "runtime", proto3);
_define_property(UpdateProcessingJobResponse, "typeName", "mono.datagateway.v1.UpdateProcessingJobResponse");
_define_property(UpdateProcessingJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProcessingJobsRequest
 */ export class ListProcessingJobsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProcessingJobsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProcessingJobsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProcessingJobsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProcessingJobsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Provide exactly one of artifact_id, project_id; status/processor narrow further.
   *
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string processor = 4;
   */ _define_property(this, "processor", ""), /**
   * @generated from field: int32 offset = 5;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProcessingJobsRequest, "runtime", proto3);
_define_property(ListProcessingJobsRequest, "typeName", "mono.datagateway.v1.ListProcessingJobsRequest");
_define_property(ListProcessingJobsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "processor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProcessingJobsResponse
 */ export class ListProcessingJobsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProcessingJobsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProcessingJobsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProcessingJobsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProcessingJobsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProcessingJob jobs = 1;
   */ _define_property(this, "jobs", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProcessingJobsResponse, "runtime", proto3);
_define_property(ListProcessingJobsResponse, "typeName", "mono.datagateway.v1.ListProcessingJobsResponse");
_define_property(ListProcessingJobsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jobs",
            kind: "message",
            T: ProcessingJob,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetJobDurationStatsRequest
 */ export class GetJobDurationStatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetJobDurationStatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobDurationStatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobDurationStatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobDurationStatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string mime_type = 1;
   */ _define_property(this, "mimeType", ""), /**
   * Coarse size bucket. Valid values: "small" (<100KB), "medium" (<10MB),
   * "large" (<100MB), "xl" (>=100MB). Other values are treated as "unknown"
   * and yield zero samples.
   *
   * @generated from field: string size_bucket = 2;
   */ _define_property(this, "sizeBucket", ""), /**
   * Minimum sample count required before pangaea returns a non-zero median.
   * Defaults to 5 server-side when omitted.
   *
   * @generated from field: int32 min_samples = 3;
   */ _define_property(this, "minSamples", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobDurationStatsRequest, "runtime", proto3);
_define_property(GetJobDurationStatsRequest, "typeName", "mono.datagateway.v1.GetJobDurationStatsRequest");
_define_property(GetJobDurationStatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "size_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "min_samples",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetJobDurationStatsResponse
 */ export class GetJobDurationStatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetJobDurationStatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobDurationStatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobDurationStatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobDurationStatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Wall-clock seconds for the median historical completion. 0 means
   * "unknown" — either fewer than min_samples comparable jobs, or no
   * matching jobs in the lookback window.
   *
   * @generated from field: int32 median_duration_seconds = 1;
   */ _define_property(this, "medianDurationSeconds", 0), /**
   * Number of jobs that contributed to the median computation. Surfaced so
   * callers can decide whether to trust a borderline-confidence estimate.
   *
   * @generated from field: int64 samples_used = 2;
   */ _define_property(this, "samplesUsed", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobDurationStatsResponse, "runtime", proto3);
_define_property(GetJobDurationStatsResponse, "typeName", "mono.datagateway.v1.GetJobDurationStatsResponse");
_define_property(GetJobDurationStatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "median_duration_seconds",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "samples_used",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToProjectRequest
 */ export class LinkArtifactToProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToProjectRequest, "runtime", proto3);
_define_property(LinkArtifactToProjectRequest, "typeName", "mono.datagateway.v1.LinkArtifactToProjectRequest");
_define_property(LinkArtifactToProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToProjectResponse
 */ export class LinkArtifactToProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ArtifactProjectLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToProjectResponse, "runtime", proto3);
_define_property(LinkArtifactToProjectResponse, "typeName", "mono.datagateway.v1.LinkArtifactToProjectResponse");
_define_property(LinkArtifactToProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ArtifactProjectLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToOutlineNodeRequest
 */ export class LinkArtifactToOutlineNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToOutlineNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToOutlineNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToOutlineNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToOutlineNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string outline_node_id = 3;
   */ _define_property(this, "outlineNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToOutlineNodeRequest, "runtime", proto3);
_define_property(LinkArtifactToOutlineNodeRequest, "typeName", "mono.datagateway.v1.LinkArtifactToOutlineNodeRequest");
_define_property(LinkArtifactToOutlineNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "outline_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToOutlineNodeResponse
 */ export class LinkArtifactToOutlineNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToOutlineNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToOutlineNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToOutlineNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToOutlineNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ArtifactProjectLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToOutlineNodeResponse, "runtime", proto3);
_define_property(LinkArtifactToOutlineNodeResponse, "typeName", "mono.datagateway.v1.LinkArtifactToOutlineNodeResponse");
_define_property(LinkArtifactToOutlineNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ArtifactProjectLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProjectArtifactLinksRequest
 */ export class ListProjectArtifactLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectArtifactLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectArtifactLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectArtifactLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectArtifactLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * When true, returns only links scoped to a specific outline node.
   *
   * @generated from field: string outline_node_id = 2;
   */ _define_property(this, "outlineNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectArtifactLinksRequest, "runtime", proto3);
_define_property(ListProjectArtifactLinksRequest, "typeName", "mono.datagateway.v1.ListProjectArtifactLinksRequest");
_define_property(ListProjectArtifactLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outline_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProjectArtifactLinksResponse
 */ export class ListProjectArtifactLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectArtifactLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectArtifactLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectArtifactLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectArtifactLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ArtifactProjectLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectArtifactLinksResponse, "runtime", proto3);
_define_property(ListProjectArtifactLinksResponse, "typeName", "mono.datagateway.v1.ListProjectArtifactLinksResponse");
_define_property(ListProjectArtifactLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: ArtifactProjectLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToEntityRequest
 */ export class LinkArtifactToEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToEntityRequest, "runtime", proto3);
_define_property(LinkArtifactToEntityRequest, "typeName", "mono.datagateway.v1.LinkArtifactToEntityRequest");
_define_property(LinkArtifactToEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkArtifactToEntityResponse
 */ export class LinkArtifactToEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToEntityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ArtifactEntityLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToEntityResponse, "runtime", proto3);
_define_property(LinkArtifactToEntityResponse, "typeName", "mono.datagateway.v1.LinkArtifactToEntityResponse");
_define_property(LinkArtifactToEntityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ArtifactEntityLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkArtifactFromEntityRequest
 */ export class UnlinkArtifactFromEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkArtifactFromEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkArtifactFromEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkArtifactFromEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkArtifactFromEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkArtifactFromEntityRequest, "runtime", proto3);
_define_property(UnlinkArtifactFromEntityRequest, "typeName", "mono.datagateway.v1.UnlinkArtifactFromEntityRequest");
_define_property(UnlinkArtifactFromEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkArtifactFromEntityResponse
 */ export class UnlinkArtifactFromEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkArtifactFromEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkArtifactFromEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkArtifactFromEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkArtifactFromEntityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkArtifactFromEntityResponse, "runtime", proto3);
_define_property(UnlinkArtifactFromEntityResponse, "typeName", "mono.datagateway.v1.UnlinkArtifactFromEntityResponse");
_define_property(UnlinkArtifactFromEntityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListEntityArtifactLinksRequest
 */ export class ListEntityArtifactLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityArtifactLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityArtifactLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityArtifactLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityArtifactLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityArtifactLinksRequest, "runtime", proto3);
_define_property(ListEntityArtifactLinksRequest, "typeName", "mono.datagateway.v1.ListEntityArtifactLinksRequest");
_define_property(ListEntityArtifactLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityArtifactLinksResponse
 */ export class ListEntityArtifactLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityArtifactLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityArtifactLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityArtifactLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityArtifactLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ArtifactEntityLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityArtifactLinksResponse, "runtime", proto3);
_define_property(ListEntityArtifactLinksResponse, "typeName", "mono.datagateway.v1.ListEntityArtifactLinksResponse");
_define_property(ListEntityArtifactLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: ArtifactEntityLink,
            repeated: true
        }
    ]));
/**
 * ChatArtifact mirrors services/pangaea/pkg/models/chat_artifact.go column-for-column.
 *
 * `id` identifies THIS VERSION; `document_id` identifies the document across all
 * of its versions. The newest non-deleted row for a document_id is "the document".
 *
 * Content bytes live in MinIO at (storage_bucket, storage_key) — deliberately NOT
 * unique, because a revert creates a new version row pointing at the previous
 * blob.
 *
 * @generated from message mono.datagateway.v1.ChatArtifact
 */ export class ChatArtifact extends Message {
    static fromBinary(bytes, options) {
        return new ChatArtifact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatArtifact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatArtifact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatArtifact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 4;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string chat_id = 5;
   */ _define_property(this, "chatId", ""), /**
   * text | code | image | sheet | presentation
   *
   * @generated from field: string kind = 6;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string storage_bucket = 8;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 9;
   */ _define_property(this, "storageKey", ""), /**
   * create | update | ai_edit | user_edit | revert
   *
   * @generated from field: string change_type = 10;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string change_description = 11;
   */ _define_property(this, "changeDescription", ""), /**
   * A user id, or the literal "ai".
   *
   * @generated from field: string created_by = 12;
   */ _define_property(this, "createdBy", ""), /**
   * active | archived | deleted
   *
   * @generated from field: string status = 13;
   */ _define_property(this, "status", ""), /**
   * Backfill provenance. legacy_row_id is the source Mongo _id (unique, the
   * idempotency key); legacy_gridfs_id is the source blob (NOT unique — revert
   * shares it). Both empty for rows written at runtime.
   *
   * @generated from field: string legacy_row_id = 14;
   */ _define_property(this, "legacyRowId", ""), /**
   * @generated from field: string legacy_gridfs_id = 15;
   */ _define_property(this, "legacyGridfsId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 18;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatArtifact, "runtime", proto3);
_define_property(ChatArtifact, "typeName", "mono.datagateway.v1.ChatArtifact");
_define_property(ChatArtifact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "legacy_row_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "legacy_gridfs_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "deleted_at",
            kind: "message",
            T: Timestamp,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ChatArtifactFilter
 */ export class ChatArtifactFilter extends Message {
    static fromBinary(bytes, options) {
        return new ChatArtifactFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatArtifactFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatArtifactFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatArtifactFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Always set by the caller to the principal's own id — the chat_artifact
   * Cerbos policy grants on ownership, so an unset owner would widen the read
   * to the whole tenant.
   *
   * @generated from field: string owner_user_id = 2;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: repeated string kinds = 3;
   */ _define_property(this, "kinds", []), /**
   * @generated from field: string title_search = 4;
   */ _define_property(this, "titleSearch", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * recent (default) | oldest | title
   *
   * @generated from field: string sort_by = 6;
   */ _define_property(this, "sortBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatArtifactFilter, "runtime", proto3);
_define_property(ChatArtifactFilter, "typeName", "mono.datagateway.v1.ChatArtifactFilter");
_define_property(ChatArtifactFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "title_search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListChatArtifactsRequest
 */ export class ListChatArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListChatArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChatArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChatArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChatArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifactFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int64 offset = 2;
   */ _define_property(this, "offset", protoInt64.zero), /**
   * @generated from field: int64 limit = 3;
   */ _define_property(this, "limit", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChatArtifactsRequest, "runtime", proto3);
_define_property(ListChatArtifactsRequest, "typeName", "mono.datagateway.v1.ListChatArtifactsRequest");
_define_property(ListChatArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ChatArtifactFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListChatArtifactsResponse
 */ export class ListChatArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListChatArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChatArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChatArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChatArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The newest version of each matching document.
   *
   * @generated from field: repeated mono.datagateway.v1.ChatArtifact artifacts = 1;
   */ _define_property(this, "artifacts", []), /**
   * Count of DOCUMENTS, not version rows.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChatArtifactsResponse, "runtime", proto3);
_define_property(ListChatArtifactsResponse, "typeName", "mono.datagateway.v1.ListChatArtifactsResponse");
_define_property(ListChatArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: ChatArtifact,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetChatArtifactRequest
 */ export class GetChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * Version-history window. limit = 0 returns the latest row only.
   *
   * @generated from field: int64 versions_offset = 3;
   */ _define_property(this, "versionsOffset", protoInt64.zero), /**
   * @generated from field: int64 versions_limit = 4;
   */ _define_property(this, "versionsLimit", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatArtifactRequest, "runtime", proto3);
_define_property(GetChatArtifactRequest, "typeName", "mono.datagateway.v1.GetChatArtifactRequest");
_define_property(GetChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "versions_offset",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "versions_limit",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetChatArtifactResponse
 */ export class GetChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifact latest = 1;
   */ _define_property(this, "latest", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ChatArtifact versions = 2;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int64 versions_total = 3;
   */ _define_property(this, "versionsTotal", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatArtifactResponse, "runtime", proto3);
_define_property(GetChatArtifactResponse, "typeName", "mono.datagateway.v1.GetChatArtifactResponse");
_define_property(GetChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "latest",
            kind: "message",
            T: ChatArtifact
        },
        {
            no: 2,
            name: "versions",
            kind: "message",
            T: ChatArtifact,
            repeated: true
        },
        {
            no: 3,
            name: "versions_total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AppendChatArtifactVersionRequest
 */ export class AppendChatArtifactVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new AppendChatArtifactVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendChatArtifactVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendChatArtifactVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendChatArtifactVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendChatArtifactVersionRequest, "runtime", proto3);
_define_property(AppendChatArtifactVersionRequest, "typeName", "mono.datagateway.v1.AppendChatArtifactVersionRequest");
_define_property(AppendChatArtifactVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ChatArtifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AppendChatArtifactVersionResponse
 */ export class AppendChatArtifactVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new AppendChatArtifactVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendChatArtifactVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendChatArtifactVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendChatArtifactVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendChatArtifactVersionResponse, "runtime", proto3);
_define_property(AppendChatArtifactVersionResponse, "typeName", "mono.datagateway.v1.AppendChatArtifactVersionResponse");
_define_property(AppendChatArtifactVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ChatArtifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertChatArtifactRequest
 */ export class UpsertChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertChatArtifactRequest, "runtime", proto3);
_define_property(UpsertChatArtifactRequest, "typeName", "mono.datagateway.v1.UpsertChatArtifactRequest");
_define_property(UpsertChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ChatArtifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertChatArtifactResponse
 */ export class UpsertChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertChatArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ChatArtifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertChatArtifactResponse, "runtime", proto3);
_define_property(UpsertChatArtifactResponse, "typeName", "mono.datagateway.v1.UpsertChatArtifactResponse");
_define_property(UpsertChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ChatArtifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteChatArtifactRequest
 */ export class DeleteChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatArtifactRequest, "runtime", proto3);
_define_property(DeleteChatArtifactRequest, "typeName", "mono.datagateway.v1.DeleteChatArtifactRequest");
_define_property(DeleteChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteChatArtifactResponse
 */ export class DeleteChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatArtifactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatArtifactResponse, "runtime", proto3);
_define_property(DeleteChatArtifactResponse, "typeName", "mono.datagateway.v1.DeleteChatArtifactResponse");
_define_property(DeleteChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[]));
